import { CloseButton } from "./Buttons";

const Modal =
  (Component) =>
  ({ showing, ...props }) => {
    if (!showing) {
      return <></>;
    }

    return (
      <div
        className="h-screen w-screen absolute inset-0 text-white flex justify-center md:items-center z-50 pb-20 sm:pb-0"
        style={{ backgroundColor: "rgba(29, 29, 29, 0.9)" }}
      >
        <CloseButton className="absolute top-4 right-10" />
        <Component {...props} />
      </div>
    );
  };

export default Modal;
